import React, { PropsWithChildren, useRef } from 'react';
import { IPqDataEntryFormProps } from '../../types/shared/PrequalificationDataEntry';
import './PqDataEntryForm.css';
import PqDataManagerProvider from './providers/PqDataManagerProvider';
import Benefits from './components/Benefits/Benefits';
import LoaderProvider from './providers/LoaderProvider';
import PagePropertiesProvider from './providers/PagePropertiesProvider';
import usePqdeSetup from './hooks/usePqdeSetup';
import HomeAddressErrorProvider from './providers/HomeAddressErrorProvider';
import PersonalInformationErrorProvider from './providers/PersonalInformationErrorProvider';
import HomeAddressProvider from './providers/HomeAddressProvider';
import PersonalInformationProvider from './providers/PersonalInformationProvider';
import DataEntryFormOrangeAsterisk from './components/versionOrangeAsteriskVariant/DEForm_OrangeAsterisk';
import DataEntryForm from './components/DataEntryForm/DataEntryForm';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';

export const PqDataEntryFormEditConfig = {
    emptyLabel: 'Pq Data Entry Form',
    isEmpty: (props: PropsWithChildren<IPqDataEntryFormProps>) =>
        !props || !props.disclaimerDesktop,
};

const PqDataEntryForm = (
    props: PropsWithChildren<IPqDataEntryFormProps>,
): JSX.Element => {
    const pageRef = useRef<HTMLDivElement>(null);

    usePqdeSetup(pageRef, props.author);
    return (
        <div ref={pageRef} id='pq-data-entry-form' className='Container PqDataEntryForm__versionA !px-0'>
            <PagePropertiesProvider pagePropertiesFromAEM={props}>
                <PqDataManagerProvider>
                    <PersonalInformationProvider>
                        <HomeAddressProvider>
                            <PersonalInformationErrorProvider>
                                <HomeAddressErrorProvider>
                                    <LoaderProvider>
                                        {props.formSubtitle && props.version === 'versionA' && (
                                            <p className='text-center'>{transformHTMLParserLinks(props.formSubtitle.replace(/\*/g, '<span class="PqDataEntryForm__asterisk">*</span>'))}</p>
                                        )}
                                        <Benefits />
                                        <div className='PqDataEntryForm__container' data-aa-pre-qualification={props.id}>
                                            {
                                                (props.version === 'orangeAsteriskVariant' ?
                                                    <DataEntryFormOrangeAsterisk />
                                                    :
                                                    <DataEntryForm
                                                        cityStateRetrievalEnabled={props.cityStateRetrievalEnabled}
                                                        isSingleAddressField={props.version === 'singleAddressVariant' ? true : false}
                                                        isInvalidAddressPopUpVariant={props.version === 'invalidAddressPopUpVariant' ? true : false}
                                                        isAddressLockVariant={props.version === 'addressLockVariant'}
                                                    />
                                                )
                                            }
                                        </div>
                                    </LoaderProvider>
                                </HomeAddressErrorProvider>
                            </PersonalInformationErrorProvider>
                        </HomeAddressProvider>
                    </PersonalInformationProvider>
                </PqDataManagerProvider>
            </PagePropertiesProvider>
        </div>
    );
};

export default PqDataEntryForm;
